export const INVITATION_STATUS = Object.freeze({
  pending: {
    title: 'Pending',
    color: '#f59e0b'
  },
  accepted: {
    title: 'Accepted',
    color: '#10b981'
  },
  cancelled: {
    title: 'Cancelled',
    color: '#ef4444'
  }
})
